import React, {useContext, useState, useEffect, useReducer} from 'react';
import { useNavigate } from 'react-router-dom'; 
import useApi from '../Hooks/useApi'
import Loader from '../Components/Loader'
import utilities from '../utilities'
import SelectControl from '../Components/SelectControl';
import {AuthContext} from '../context/AuthContext'
import swal from 'sweetalert'


const Corrected = (props) => {

    const {userInfo} = useContext(AuthContext);
    const navigate = useNavigate();
    const {data} = useApi( {url: '/Registration/GetScrutinyApplications?status=Corrected', method: 'get' });


  return (
    <>

<div className="content">
    <div className="header">
        <label className="title"> Corrected Applications </label>
    </div>
    <p className='text-primary'>***These application(s) will be checked by officer at PMF and the status will be updated accordingly</p>

    {!data ? (<Loader />) : (

    
                                <div className="body">
                                    <div className="animate-bottom">
                                                    {data.map((category, index) => {
                                                        return (
                                                            <div className="table-responsive" > 
                                                            <table className='table table-striped table-hover table-bordered caption-top'>
                                                                <caption >
                                                                    <span key={index}> {category.name} </span>
                                                                </caption>
                                                                <thead className="table-light">
                                                                    <tr>
                                                                        <th>Session</th>
                                                                        <th>Category</th>
                                                                        <th>Student Name</th>
                                                                        <th>Father Name</th>
                                                                        <th>CNIC</th>
                                                                        <th>Removed Objection(s)</th>
                                                                    </tr>
                                                                </thead>
                                                                
                                                                <tbody>

                                                                {category.students.map((student, i) => {
                                                                    return (
                                                                        <>
                                                                            <tr key={student.studentID}>
                                                                                <td>{student.session}</td>
                                                                                <td>{student.category}</td>                                                                                
                                                                                <td>{student.studentName}</td>
                                                                                <td>{student.fatherName}</td>
                                                                                <td>{student.cnic}</td>
                                                                                <td style={{textAlign:'left'}}>
                                                                                    <span className='text-danger'>
                                                                                        {student.isValidCNIC == false ? [student.cnicObjection, <br/>,<hr style={{margin:'5px', color: 'black'}}></hr>] : null}
                                                                                        {student.isValidMatricDMC == false ? [student.matricObjection, <br/>, ,<hr style={{margin:'5px', color: 'black'}}></hr>] : null}
                                                                                        {student.isValidMatricVerification == false ? student.verificationObjection: null}
                                                                                    </span>
                                                                                </td>                                                                                
                                                                            </tr>
                                                                        </>
                                                                    )
                                                                  })
                                                                }
                                                                </tbody>
                                                        </table>
                                                        </div>
                                                        );

                                                    })
                                                    }

                                    </div>


                                    
                                </div>
        )
    }
                                </div>

    </>
  );

};

export default Corrected;